"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _AdobeSocialColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeSocialColorLight"));

var _CircleExperienceCloud = _interopRequireDefault(require("@exc/brand-icons/brand/CircleExperienceCloud.svg"));

var AnnouncementSelectors = _interopRequireWildcard(require("../../store/reducers/AnnouncementReducer"));

var _store = _interopRequireDefault(require("../../store/store"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var SolutionIcon = function SolutionIcon(props) {
  var product = props.product;
  var userEntitlements = AnnouncementSelectors.getUserEntitlements(_store.default.getState()); //Show default icon ExerienceCloud for announcement and notifications

  var productIcon = _react.default.createElement("img", {
    alt: product,
    src: _CircleExperienceCloud.default
  });

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = userEntitlements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var userEntitlement = _step.value;
      var skip = false;

      if (product == userEntitlement.name && !skip) {
        skip = true;
        productIcon = _react.default.createElement("img", {
          alt: userEntitlement.name,
          src: userEntitlement.functionalIconUrl
        });
      }
    } //TODO remove once Social Product is deprecated

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (product == 'Social') {
    productIcon = _react.default.createElement(_AdobeSocialColorLight.default, {
      className: "pulse-announcement-solution-icon",
      size: "L"
    });
  }

  return productIcon;
};

var _default = SolutionIcon;
exports.default = _default;